import dayjs from "dayjs"

export const clearFilterData = {
  SalDte: null,
  IsHasInvId: 0
}

export const initFilterData = {
  SalDte: dayjs().startOf('month'),
  IsHasInvId: 1
}